import { join } from 'light-component';
import { ReactElement } from 'react';
import { Box } from '@common';
import styles from '../style.module.less';
import { Highlighter } from '../../component';
import { GridDesigner } from './grid-designer';
import type { ShotEyesGridProps } from './types';

export function ShotEyesGridViewMode(props: ShotEyesGridProps): ReactElement {
  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={join(styles.inputContent, styles.content)}>
        <GridDesigner {...props} type='input' onChange={() => null} />
      </Box>
    </Box>
  );
}
